import { text_colorTextPrimary } from 'ext-ui/style/colors'
import { spacing, table_borderRadius } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export const staticPillClassName = 'BulkInviteMappingGrid-staticPill'

export const fieldLabelContent = css`
  display: inline-flex;
  align-items: center;
  gap: ${spacing(2)};
  color: ${text_colorTextPrimary};

  .${staticPillClassName} {
    pointer-events: none;
  }
`

export const dropdownCell = css`
  width: 240px;
  max-width: 100%;
`

// Clip the DataGrid to the Box's rounded corners so the grid's square edges
// don't bleed past the outlined border. Scoped here (not on the shared Box)
// because global clipping would cut off absolutely-positioned popovers in
// other outlineBorder Box consumers.
export const gridClip = css`
  overflow: hidden;
  border-radius: ${table_borderRadius};

  /* Rows aren't selectable here, so suppress the shared DataGrid's row-hover
     highlight (it reads as a selection affordance). The grid drives every hover
     background off this custom property. */
  .MuiDataGrid-root {
    --hover-color: transparent;
  }
`
